<template>
  <div class="results">
    <table class="table">
      <thead>
        <tr>
          <th>Titulo</th>
          <th class="date">Fecha</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tender in tenders" :key="tender.id">
          <td>
            <a :href="tender.file" target="_blank">{{ tender.title }}</a>
          </td>
          <td>{{ tender.publish_date }}</td>
        </tr>
      </tbody>
    </table>
    <div class="empty" v-if="!tenders.length && !isLoading">
      <h4>No se encontraron resultados.</h4>
    </div>
    <paginate
      class="mt-5"
      v-if="totalPages > 1"
      v-model="page"
      v-show="!isLoading"
      :page-count="totalPages"
      :prev-text="'Anterior'"
      :next-text="'Siguiente'"
      :container-class="'pagination d-flex justify-content-center'"
      :page-link-class="'page-link'"
      :page-class="'page-item'"
      :prev-link-class="'page-link'"
      :prev-class="'page-item'"
      :next-link-class="'page-link'"
      :next-class="'page-item'"
      :clickHandler="handlePaginationClick"
    ></paginate>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Tenders',
  data() {
    return {
      siteUrl: window.ui_tenders_data.site_url,
      apiPath: 'wp-json/tenders/v1',
      tenders: [],
      isLoading: true,
      page: 1,
      totalPages: 0,
      totalResources: 0,
      maxPages: 0,
      tendersPerPage: 0,
    };
  },
  mounted() {
    this.getTenders();
  },
  methods: {
    getTenders() {
      this.isLoading = true;
      const apiUrl = `${this.siteUrl}/${this.apiPath}/tenders`;
      axios
        .post(apiUrl, { page: this.page })
        .then((response) => {
          if (response.status === 200) {
            this.tenders = response.data.tenders;
            this.page = response.data.page;
            this.totalPages = response.data.max_num_pages;
            this.totalResources = response.data.total;
            this.maxPages = response.data.max;
            this.resourcesPerPage = response.data.posts_per_page;
          } else {
            // console.log('error :', response.status);
          }
          this.isLoading = false;
        })
        .catch((err) => {
          // console.log('Error :', err);
        });
    },
    handlePaginationClick(pageNum) {
      this.page = pageNum;
      this.getTenders();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
td a {
  color: #00124c !important;
}
.page-item.active .page-link {
  color: #fff !important;
}
.results {
  thead {
    background: #eafaf6;
    .date {
      width: 20%;
    }
  }
  tbody {
    .resource {
      text-align: center !important;
      text-decoration: underline;
    }
    .type {
      text-align: center !important;
      font-weight: bold;
    }
  }

  .pagination {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    padding: 0 !important;
    margin: 0 !important;
    list-style: none !important;
    border-radius: 0.25rem !important;
    list-style: none !important;
  }

  .page-item.disabled .page-link {
    color: #6c757d !important;
    pointer-events: none !important;
    cursor: auto !important;
    background-color: #fff !important;
    border-color: #dee2e6 !important;
  }

  .page-item:first-child .page-link {
    margin-left: 0 !important;
    border-top-left-radius: 0.25rem !important;
    border-bottom-left-radius: 0.25rem !important;
  }

  .page-item:last-child .page-link {
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }

  .page-item.active .page-link {
    z-index: 1 !important;
    color: #fff !important;
    background-color: #00124c !important;
    border-color: #00124c !important;
  }

  .page-link:not(:disabled):not(.disabled) {
    cursor: pointer !important;
  }

  .page-link {
    position: relative !important;
    display: block !important;
    padding: 0.5rem 0.75rem !important;
    margin-left: -1px !important;
    line-height: 1.25 !important;
    color: #00124c !important;
    background-color: #fff !important;
    border: 1px solid #dee2e6 !important;
  }

  .page-item {
    list-style: none !important;
  }

  .col,
  .col-1,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-10,
  .col-11,
  .col-12,
  .col-auto,
  .col-lg,
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg-auto,
  .col-md,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-auto,
  .col-sm,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm-auto,
  .col-xl,
  .col-xl-1,
  .col-xl-2,
  .col-xl-3,
  .col-xl-4,
  .col-xl-5,
  .col-xl-6,
  .col-xl-7,
  .col-xl-8,
  .col-xl-9,
  .col-xl-10,
  .col-xl-11,
  .col-xl-12,
  .col-xl-auto {
    position: relative !important;
    width: 100% !important;
    min-height: 1px !important;
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
}
</style>
